export default "__VITE_ASSET__DwrzcfA8__"